export enum AuthAccessibilityType {
  onlyLoggedIn,
  onlyNotLoggedIn,
  onlyVenueSelected,
}
